module.exports = __webpack_public_path__ + "img/actions.b1ed0df9.jpg";